var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
import { createBreakpoints } from '@mui/system';
var breakpoints = createBreakpoints({});
//todo: typography 수정필요!
export var typography = {
    fontFamily: "Noto Sans KR, -apple-system , Malgun Gothic, sans-serif , Apple SD Gothic Neo",
    h1: (_a = {
            fontWeight: '700',
            fontSize: "1.75rem"
        },
        _a[breakpoints.down('sm')] = {
            fontSize: "1.5rem", //24
        },
        _a),
    h2: (_b = {
            fontWeight: '700',
            fontSize: "1.5rem"
        },
        _b[breakpoints.down('sm')] = {
            fontSize: "1.375rem", //22
        },
        _b),
    h3: (_c = {
            fontWeight: '700',
            fontSize: "1.25rem"
        },
        _c[breakpoints.down('sm')] = {
            fontSize: "1.125rem", //18
        },
        _c),
    h4: (_d = {
            fontWeight: '700',
            fontSize: "1.125rem"
        },
        _d[breakpoints.down('sm')] = {
            fontSize: "1rem", //16
        },
        _d),
    subtitle1: (_e = {
            fontWeight: '500',
            fontSize: "1rem"
        },
        _e[breakpoints.down('sm')] = {
            fontSize: "0.938rem", //15
        },
        _e),
    subtitle1_700: (_f = {
            fontWeight: '700',
            fontSize: "1rem"
        },
        _f[breakpoints.down('sm')] = {
            fontSize: "0.938rem", //15
        },
        _f),
    subtitle1_500: (_g = {
            fontWeight: '500',
            fontSize: "1rem"
        },
        _g[breakpoints.down('sm')] = {
            fontSize: "0.938rem", //15
        },
        _g),
    subtitle1_400: (_h = {
            fontWeight: '400',
            fontSize: "1rem"
        },
        _h[breakpoints.down('sm')] = {
            fontSize: "0.938rem", //15
        },
        _h),
    subtitle2: (_j = {
            fontWeight: '400',
            fontSize: "0.938rem"
        },
        _j[breakpoints.down('sm')] = {
            fontSize: "0.875rem", //14
        },
        _j),
    subtitle2_700: (_k = {
            fontWeight: '700',
            fontSize: "0.938rem"
        },
        _k[breakpoints.down('sm')] = {
            fontSize: "0.875rem", //14
        },
        _k),
    subtitle2_500: (_l = {
            fontWeight: '500',
            fontSize: "0.938rem"
        },
        _l[breakpoints.down('sm')] = {
            fontSize: "0.875rem", //14
        },
        _l),
    subtitle2_400: (_m = {
            fontWeight: '400',
            fontSize: "0.938rem"
        },
        _m[breakpoints.down('sm')] = {
            fontSize: "0.875rem", //14
        },
        _m),
    body1: (_o = {
            fontWeight: '400',
            fontSize: "0.875rem"
        },
        _o[breakpoints.down('sm')] = {
            fontSize: "0.813rem", //13
        },
        _o),
    body1_700: (_p = {
            fontWeight: '700',
            fontSize: "0.875rem"
        },
        _p[breakpoints.down('sm')] = {
            fontSize: "0.813rem", //13
        },
        _p),
    body1_500: (_q = {
            fontWeight: '500',
            fontSize: "0.875rem"
        },
        _q[breakpoints.down('sm')] = {
            fontSize: "0.813rem", //13
        },
        _q),
    body1_400: (_r = {
            fontWeight: '400',
            fontSize: "0.875rem"
        },
        _r[breakpoints.down('sm')] = {
            fontSize: "0.813rem", //13
        },
        _r),
    body2: (_s = {
            fontWeight: '400',
            fontSize: "0.813rem"
        },
        _s[breakpoints.down('sm')] = {
            fontSize: "0.75rem", //12
        },
        _s),
    body2_700: (_t = {
            fontWeight: '700',
            fontSize: "0.813rem"
        },
        _t[breakpoints.down('sm')] = {
            fontSize: "0.75rem", //12
        },
        _t),
    body2_500: (_u = {
            fontWeight: '500',
            fontSize: "0.813rem"
        },
        _u[breakpoints.down('sm')] = {
            fontSize: "0.75rem", //12
        },
        _u),
    body2_400: (_v = {
            fontWeight: '400',
            fontSize: "0.813rem"
        },
        _v[breakpoints.down('sm')] = {
            fontSize: "0.75rem", //12
        },
        _v),
    body3: (_w = {
            fontWeight: '400',
            fontSize: "0.75rem"
        },
        _w[breakpoints.down('sm')] = {
            fontSize: "0.688rem", //11
        },
        _w),
    body3_700: (_x = {
            fontWeight: '700',
            fontSize: "0.75rem"
        },
        _x[breakpoints.down('sm')] = {
            fontSize: "0.688rem", //11
        },
        _x),
    body3_500: (_y = {
            fontWeight: '500',
            fontSize: "0.75rem"
        },
        _y[breakpoints.down('sm')] = {
            fontSize: "0.688rem", //11
        },
        _y),
    body3_400: (_z = {
            fontWeight: '400',
            fontSize: "0.75rem"
        },
        _z[breakpoints.down('sm')] = {
            fontSize: "0.688rem", //11
        },
        _z),
    body4: (_0 = {
            fontWeight: '400',
            fontSize: "0.688rem"
        },
        _0[breakpoints.down('sm')] = {
            fontSize: "0.625rem", //10
        },
        _0),
    body4_700: (_1 = {
            fontWeight: '700',
            fontSize: "0.688rem"
        },
        _1[breakpoints.down('sm')] = {
            fontSize: "0.625rem", //10
        },
        _1),
    body4_500: (_2 = {
            fontWeight: '500',
            fontSize: "0.688rem"
        },
        _2[breakpoints.down('sm')] = {
            fontSize: "0.625rem", //10
        },
        _2),
    body4_400: (_3 = {
            fontWeight: '400',
            fontSize: "0.688rem"
        },
        _3[breakpoints.down('sm')] = {
            fontSize: "0.625rem", //10
        },
        _3),
};
//# sourceMappingURL=typography.js.map